import {Inject, Injectable} from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import {Location} from '@angular/common';
import {AppConfig} from 'common-shared';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {
  constructor(private router: Router, private location: Location, @Inject('config') private appConfig: AppConfig) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (localStorage.getItem(getAuthTokenKey(this.appConfig.name))) {
      return true;
    }

    // not logged in so redirect to login page with the return url

    const prevReturnUrl = new URLSearchParams(location.search).get('returnUrl');
    this.router.navigate(['/login'], {queryParams: {returnUrl: prevReturnUrl || state.url}})
      .catch(reason => console.error(reason));
    return false;
  }
}

export function getAuthTokenKey(name: string) {
  return name + ':authorizationData';
}
